export class CacheConstant {
  static readonly StaticData = {
    NuctracGroup: 'nuctrac-group',
    TypeGroup: 'typeGroupRefList',
    TypeRef: 'typeRefList',
    MessageRef: 'messageRefList',
    AppPreference: 'appPreferenceList',
    TimeZone: 'timezoneList',
    Pages: 'pageList',
    TemplateCategory: 'templateCategoryList',
    Details: "Details"
  };


  static readonly SessionStorageData = {
    AuthenticationToken: 'authenticationToken',
    AccessToken: 'accessToken',
    IdToken: 'idToken',
    AuthToken: 'authToken',
    ShipTo: 'shipto',
    Permissions: 'permissions',
    NuctracAppPreferences: 'nuctracAppPreferences',
    NuctracAppMaintenance: 'nuctracAppMaintenance',
    LoggedInUser: 'loggedInUser',
    LoggedInUserID: "loggedInUserID",
    AllDigiRadDepartments: 'allDigiRadDepartments',
    CustomerSsoFlag: 'customerSsoFlag',
    IsAccountHuborFacility: 'isAccountHuborFacility',
    LocationNumber: 'locationNumber',
    SsoValidationFlag: 'ssoValidationFlag',
    UserSsoFlag: 'userSsoFlag',
    DefaultShipTo: 'DefaultShipTo',
    TimeZoneText: 'timeZoneText',
    MobileDetails:'mobileDetails',
    RefreshToken: 'refreshToken'
  };

  static readonly WOLocalStorage = {
    UserDetails: 'UserDetails'
  }

  static readonly LocalStorage = {
    AccessToken: 'accessToken',
    AccountDetails: 'accountDetails',
    ActiveUsersList: 'active-user-list',
    AlertCount: 'alertCount',
    Components: 'components',
    CustomerAdminSettings: 'customerAdminSettings',
    IdToken: 'idToken',
    isCustomerMigratedToNewWO:'isCustomerMigratedToNewWO',
    LocationNum: 'locationNum',
    MobileCnfgs:'MobileCnfgs',
    OrderingPhysicians: 'orderingPhysicians',
    Preferences: 'preferences',
    Products: 'products',
    Procedures: 'procedures',
    PurchaseOrders: 'purchaseOrders',
    RecurringOrders: 'recurringOrders',
    RecurringOrderTemplateExists:'recurringOrderTemplateExists',
    ReferringPhysicians: 'referringPhysicians',
    ShipTo: 'ShipTo',
    SpecialProducts: 'specialProducts',
    ProductValidations: 'productValidations',
    StaticData: 'staticData',
    Supplies: 'supplies',
    Uoms: 'uoms',
    UserDetails: 'userDetails',
    UserNum: 'userNum',
    CurrentTime: 'currentTime',
    NoRoleAssigned: 'noRoleAssigned',
    NoRoleAssignedMsg: 'NoRoleAssignedMsg',
    OrderDataLoaded: 'orderDataLoaded',
    PrevEligId: 'prevEligId',
    NewEligId: 'newEligId',
    RefreshTokenCounter: 'refreshTokenCounter',
    PhamacyHolidayList: 'phamacyHolidayList',
    SelectedAccount:'selectedAccount',
    nonOrderableMaterialIds:'nonOrderableMaterialId',
    nonReturnableMaterialIds:'nonReturnableMaterialId',
    patientBenefitEligibleProducts: 'patientBenefitEligibleProducts'
  };

  static readonly CacheAppData = {
    Name: 'App',
    Items: {
      IsServiceLoaded: 'IsServiceLoaded',
      AppLoaded: 'AppLoaded',
      SessionExpired: "SessionExpired",
      UpdateAvailable: "UpdateAvailable",
      CacheUpdated: "CacheUpdated",
      UserDetails: "UserDetails",
      DeviceDeatils: "DeviceDeatils",
      AccountDetails: "AccountDetails",
      Procedures: 'Procedures',
      RecurringOrders: 'RecurringOrders',
      OrderReport: "OrderReport"
    }
  };

  static readonly Properties = {
    UserDetailNum: "userDetailNum",
    DefaultShipToNumber: "defaultShipToNumber",
    CustomerAccountsList: "customerAccountsList",
    InvoiceAccountsList: "invoiceAccountsList",
    UserRoleList: "userRoleXrefList",
    UserPreferences: "userPreferences",
    EmailId: "emailId" ,
    CustomerShipToNum: "customerShipToNum",
    AlertCount: 'alertCount'
  };

  static readonly AppData = {
    UserProfile: "UserProfile",
    SessionExpired: "SessionExpired",
    Roles: "Roles",
    Email: "Email",
    AccountSettings: "AccountSettings",
    NuctracGroups: "NuctracGroups",
    NuctracModules: "NuctracModules",
    NuctracProducts: "NuctracProducts",
    NuctracOrders: "NuctracOrders"
  };

  static readonly _cacheNames = { appData: 'App', staticData: 'Static', httpHeaders: 'HttpHeaders' }

  static readonly MasterData = {
    Customer: 'customer-data',
    Item: 'item'

  };

  static readonly OktaAuth = 'okta-auth';
  static readonly UserAuth = 'user-auth';
  static readonly UserPreferences = 'user-preferences';
}
